const style = {
  wrapper: {
    '@media (min-width: 992px)': {
      padding: `0 25px`
    }
  },
  row: {
    border: `1px solid transparent`,
    borderBottom: `1px solid #f4f4f4`,
    cursor: `pointer`,
    ':hover': {
      border: `1px solid #ececec`,
      background: `#fbfbfb`,
      borderRadius: `3px`
    },
    padding: `20px 15px`,
    '@media (min-width: 992px)': {
      padding: `20px`
    }
  },
  activeRow: {
    border: `1px solid #ececec`,
    background: `#fbfbfb`,
    borderRadius: `3px`
  },
  header: {
    borderBottom: `1px solid #ececec`,
    padding: `10px 20px`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Statistics/partials/RevenueTable/style/list.js